// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sign-in page — brand showcase (always dark) + theme-aware auth panel */

.auth-container.auth-container--rt {
  background: var(--bg-primary);
}

/* ── Left: brand showcase ─────────────────────────────────────────── */
.auth-container--rt .auth-left-section {
  background-color: #060d1a;
  background-image:
    radial-gradient(ellipse 70% 55% at 15% 10%, rgba(59, 130, 246, 0.28), transparent 60%),
    radial-gradient(ellipse 60% 50% at 90% 95%, rgba(20, 184, 166, 0.16), transparent 60%),
    linear-gradient(165deg, #060d1a 0%, #0a1629 55%, #07111f 100%);
  color: #e2e8f0;
  overflow: hidden;
}

.auth-container--rt .auth-left-section::before {
  content: '';
  position: absolute;
  inset: 0;
  background-image: linear-gradient(rgba(148, 163, 184, 0.06) 1px, transparent 1px),
    linear-gradient(90deg, rgba(148, 163, 184, 0.06) 1px, transparent 1px);
  background-size: 44px 44px;
  mask-image: radial-gradient(ellipse 75% 65% at 50% 45%, #000 30%, transparent 80%);
  -webkit-mask-image: radial-gradient(ellipse 75% 65% at 50% 45%, #000 30%, transparent 80%);
  pointer-events: none;
}

.auth-showcase {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 26px;
  width: min(480px, 84%);
  max-height: 100%;
  padding: 32px 0;
}

.auth-showcase__brand {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #f8fafc;
}

.auth-showcase__brand img {
  width: 32px;
  height: 32px;
  border-radius: 8px;
}

.auth-showcase__copy h2 {
  margin: 0 0 10px;
  font-size: clamp(26px, 2.6vw, 34px);
  font-weight: 650;
  line-height: 1.15;
  letter-spacing: -0.03em;
  color: #f8fafc;
}

.auth-showcase__copy p {
  margin: 0;
  max-width: 42ch;
  font-size: 15px;
  line-height: 1.55;
  color: rgba(203, 213, 225, 0.78);
}

.auth-showcase__points {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 18px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.auth-showcase__points li {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-size: 13px;
  color: rgba(203, 213, 225, 0.82);
}

.auth-showcase__points svg {
  color: #60a5fa;
}

/* Product window */
.asv-window {
  border-radius: 14px;
  background: rgba(13, 24, 43, 0.82);
  border: 1px solid rgba(148, 163, 184, 0.14);
  box-shadow: 0 30px 70px rgba(0, 0, 0, 0.45), inset 0 1px 0 rgba(255, 255, 255, 0.04);
  backdrop-filter: blur(6px);
  overflow: hidden;
}

.asv-window__bar {
  display: flex;
  align-items: center;
  gap: 12px;
  height: 38px;
  padding: 0 14px;
  border-bottom: 1px solid rgba(148, 163, 184, 0.1);
  background: rgba(255, 255, 255, 0.02);
}

.asv-window__dots {
  display: inline-flex;
  gap: 6px;
}

.asv-window__dots i {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: rgba(148, 163, 184, 0.28);
}

.asv-window__title {
  font-size: 12px;
  color: rgba(148, 163, 184, 0.85);
  font-family: var(--font-mono);
}

.asv-pipeline {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 6px;
  margin: 0;
  padding: 12px;
  list-style: none;
}

.asv-stage {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px;
  border-radius: 10px;
  border: 1px solid transparent;
  transition: background 320ms ease, border-color 320ms ease;
}

.asv-stage:not(:last-child)::after {
  content: '';
  position: absolute;
  top: 24px;
  right: -6px;
  width: 6px;
  height: 1px;
  background: rgba(148, 163, 184, 0.25);
}

.asv-stage__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  color: rgba(148, 163, 184, 0.9);
  background: rgba(148, 163, 184, 0.08);
  transition: background 320ms ease, color 320ms ease, box-shadow 320ms ease;
}

.asv-stage__text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.asv-stage__label {
  font-size: 12px;
  font-weight: 600;
  color: rgba(226, 232, 240, 0.72);
}

.asv-stage__meta {
  font-size: 10.5px;
  line-height: 1.35;
  color: rgba(148, 163, 184, 0.62);
}

.asv-stage.is-done .asv-stage__icon {
  color: #34d399;
  background: rgba(52, 211, 153, 0.12);
}

.asv-stage.is-active {
  background: rgba(59, 130, 246, 0.1);
  border-color: rgba(59, 130, 246, 0.35);
}

.asv-stage.is-active .asv-stage__icon {
  color: #fff;
  background: #3b82f6;
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.18);
}

.asv-stage.is-active .asv-stage__label {
  color: #f8fafc;
}

.asv-panel {
  margin: 0 12px 12px;
  padding: 12px 14px 14px;
  min-height: 150px;
  border-radius: 10px;
  background: rgba(6, 13, 26, 0.7);
  border: 1px solid rgba(148, 163, 184, 0.08);
  animation: asv-fade 320ms var(--ease-out, ease);
}

.asv-panel__head {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: rgba(148, 163, 184, 0.8);
}

.asv-panel__dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
  animation: asv-pulse 1.4s ease-in-out infinite;
}

.asv-line,
.asv-code__line,
.asv-exec__row {
  opacity: 0;
  animation: asv-rise 360ms var(--ease-out, ease) forwards;
}

.asv-create {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.asv-line {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 12.5px;
  color: #cbd5e1;
}

.asv-line__num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 5px;
  font-size: 10px;
  font-weight: 700;
  color: #93c5fd;
  background: rgba(59, 130, 246, 0.14);
}

.asv-code {
  font-family: var(--font-mono);
  font-size: 11.5px;
  line-height: 1.75;
  color: #a5b4fc;
}

.asv-code__line:nth-child(n + 2):nth-last-child(n + 2) {
  color: #7dd3fc;
}

.asv-exec {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-top: 4px;
}

.asv-exec__row {
  display: grid;
  grid-template-columns: 120px 1fr;
  align-items: center;
  gap: 12px;
}

.asv-exec__name {
  font-size: 12px;
  color: #cbd5e1;
}

.asv-exec__track {
  height: 6px;
  border-radius: 999px;
  background: rgba(148, 163, 184, 0.14);
  overflow: hidden;
}

.asv-exec__fill {
  display: block;
  height: 100%;
  width: 0;
  border-radius: inherit;
  background: linear-gradient(90deg, #3b82f6, #22d3ee);
  animation: asv-fill 1.6s var(--ease-out, ease) forwards;
}

.asv-results {
  display: flex;
  align-items: center;
  gap: 22px;
}

.asv-ring {
  position: relative;
  width: 92px;
  height: 92px;
  flex-shrink: 0;
}

.asv-ring > svg {
  width: 100%;
  height: 100%;
  transform: rotate(-90deg);
}

.asv-ring > svg circle {
  fill: none;
  stroke-width: 3.2;
}

.asv-ring__track {
  stroke: rgba(148, 163, 184, 0.16);
}

.asv-ring__value {
  stroke: #34d399;
  stroke-linecap: round;
  stroke-dasharray: 97.4;
  stroke-dashoffset: 97.4;
  animation: asv-ring 1.4s var(--ease-out, ease) forwards;
}

.asv-ring__label {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 3px;
  font-size: 11px;
  font-weight: 600;
  color: #a7f3d0;
}

.asv-ring__label svg {
  width: 16px;
  height: 16px;
  color: #34d399;
  flex-shrink: 0;
}

.asv-bars {
  flex: 1 1;
  display: flex;
  align-items: flex-end;
  gap: 8px;
  height: 84px;
}

.asv-bars span {
  flex: 1 1;
  height: 0;
  border-radius: 4px 4px 2px 2px;
  background: linear-gradient(180deg, rgba(96, 165, 250, 0.9), rgba(59, 130, 246, 0.35));
  animation: asv-bar 900ms var(--ease-out, ease) forwards;
}

@keyframes asv-fade {
  from { opacity: 0; transform: translateY(4px); }
  to { opacity: 1; transform: none; }
}

@keyframes asv-rise {
  from { opacity: 0; transform: translateY(6px); }
  to { opacity: 1; transform: none; }
}

@keyframes asv-fill {
  to { width: var(--asv-w); }
}

@keyframes asv-bar {
  to { height: var(--asv-h); }
}

@keyframes asv-ring {
  to { stroke-dashoffset: 7.8; }
}

@keyframes asv-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
}

@media (max-height: 760px) {
  .auth-showcase__points {
    display: none;
  }

  .auth-showcase {
    gap: 18px;
  }
}

/* ── Right: auth panel (theme-aware) ──────────────────────────────── */
.auth-container--rt .auth-right-section {
  background: var(--bg-primary);
  background-image: radial-gradient(circle at 80% 10%, var(--primary-subtle), transparent 45%);
  overflow-y: auto;
  align-items: safe center;
  padding: 32px 24px;
}

.auth-container--rt .auth-card {
  max-width: 420px;
  max-height: none;
  margin: auto 0;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 16px;
  box-shadow: var(--shadow-lg);
}

.auth-container--rt .auth-header {
  min-height: auto;
  padding: 28px 28px 8px;
}

.auth-container--rt .auth-header::before {
  display: none;
}

.auth-container--rt .auth-logo {
  width: 48px;
  height: 48px;
  padding: 10px;
  margin-bottom: 14px;
  border-radius: 12px;
  background: var(--primary-subtle);
  border: 1px solid var(--primary-muted);
  box-shadow: none;
}

.auth-container--rt .auth-title {
  margin: 0 0 6px;
  color: var(--text-primary);
  font-size: 22px;
  font-weight: 650;
  letter-spacing: -0.02em;
}

.auth-container--rt .auth-subtitle {
  margin: 0;
  color: var(--text-secondary);
  font-size: 13.5px;
  max-width: 320px;
}

.auth-container--rt .auth-body {
  padding: 16px 28px 20px;
}

.auth-container--rt .auth-login-tabs {
  display: flex;
  gap: 4px;
  padding: 4px;
  margin-bottom: 18px;
  border: 1px solid var(--border);
  border-bottom: 1px solid var(--border);
  border-radius: 10px;
  background: var(--bg-tertiary);
}

.auth-container--rt .auth-login-tab {
  flex: 1 1;
  height: 32px;
  border: none;
  border-radius: 7px;
  background: transparent;
  color: var(--text-secondary);
  font-size: 13px;
  font-weight: 600;
  transition: background var(--duration-fast, 120ms) ease, color var(--duration-fast, 120ms) ease,
    box-shadow var(--duration-fast, 120ms) ease;
}

.auth-container--rt .auth-login-tab:hover {
  color: var(--text-primary);
  background: transparent;
}

.auth-container--rt .auth-login-tab.active {
  color: var(--text-primary);
  background: var(--surface);
  border-bottom: none;
  box-shadow: var(--shadow-sm);
}

[data-theme='dark'] .auth-container--rt .auth-login-tab.active {
  background: var(--surface-selected);
}

.auth-container--rt .form-label {
  color: var(--text-secondary);
  font-size: 13px;
  font-weight: 600;
}

.auth-container--rt .form-control,
.auth-container--rt .form-input,
.auth-container--rt input[type='email'],
.auth-container--rt input[type='password'],
.auth-container--rt input[type='text'],
.auth-container--rt input[type='tel'] {
  height: 42px;
  background: var(--input-background) !important;
  border: 1px solid var(--input-border) !important;
  color: var(--text-primary) !important;
  border-radius: 10px !important;
  font-size: 14px;
}

.auth-container--rt .form-control::placeholder,
.auth-container--rt .form-input::placeholder,
.auth-container--rt input::placeholder {
  color: var(--input-placeholder) !important;
}

.auth-container--rt .form-control:focus,
.auth-container--rt .form-input:focus,
.auth-container--rt input:focus {
  border-color: var(--primary) !important;
  box-shadow: var(--shadow-focus) !important;
  outline: none;
}

.auth-container--rt .relative > span,
.auth-container--rt .relative > button {
  color: var(--text-muted) !important;
}

.auth-container--rt .forgot-password,
.auth-container--rt a.forgot-password,
.auth-container--rt .auth-link,
.auth-container--rt .btn-link {
  color: var(--primary) !important;
  background: none !important;
  border: none !important;
  padding: 0 !important;
  font-size: 12.5px;
  font-weight: 600;
  cursor: pointer;
}

.auth-container--rt .remember-me,
.auth-container--rt .remember-me-label,
.auth-container--rt .checkbox-label,
.auth-container--rt label[for='rememberMe'] {
  color: var(--text-secondary);
  font-size: 13px;
}

.auth-container--rt .remember-me-checkbox {
  accent-color: var(--primary);
}

.auth-container--rt .btn-primary,
.auth-container--rt button[type='submit'].btn-primary,
.auth-container--rt .auth-submit-btn {
  height: 42px;
  background: var(--primary) !important;
  background-image: none !important;
  border: none !important;
  border-radius: 10px !important;
  font-weight: 600;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.18), inset 0 1px 0 rgba(255, 255, 255, 0.1) !important;
  color: #fff !important;
  transition: background var(--duration-fast, 120ms) ease, transform 80ms ease;
}

.auth-container--rt .btn-primary:hover:not(:disabled),
.auth-container--rt .auth-submit-btn:hover:not(:disabled) {
  background: var(--primary-hover) !important;
}

.auth-container--rt .btn-primary:active:not(:disabled) {
  transform: translateY(0.5px);
}

.auth-container--rt .form-error {
  color: var(--danger);
  font-size: 12.5px;
}

.auth-container--rt .form-text {
  color: var(--text-muted);
  font-size: 12px;
  margin-top: 6px;
}

.auth-container--rt .form-text--success {
  color: var(--success, #16a34a);
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 4px;
}

.auth-container--rt .form-input--readonly {
  background: var(--bg-tertiary) !important;
  cursor: not-allowed;
}

.auth-container--rt .auth-muted {
  color: var(--text-secondary);
  font-size: 14px;
  line-height: 1.5;
  margin: 0;
}

.auth-container--rt .auth-password-field {
  position: relative;
}

.auth-container--rt .auth-password-field .form-input {
  padding-right: 40px;
  width: 100%;
}

.auth-container--rt .auth-password-toggle {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-muted) !important;
}

.auth-container--rt .divider {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 16px 0;
}

.auth-container--rt .divider::before,
.auth-container--rt .divider::after {
  content: '';
  flex: 1 1;
  height: 1px;
  background: var(--border);
}

.auth-container--rt .divider-text {
  color: var(--text-muted);
  font-size: 12px;
}

.auth-container--rt .auth-steps {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.auth-container--rt .auth-step {
  display: flex;
  gap: 14px;
  align-items: flex-start;
}

.auth-container--rt .auth-step__badge {
  width: 28px;
  height: 28px;
  border-radius: 999px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2px;
  font-size: 12px;
  font-weight: 700;
  color: var(--primary);
  background: var(--primary-subtle);
  border: 1px solid var(--primary-muted);
}

.auth-container--rt .auth-step__badge--done {
  color: #fff;
  background: var(--primary);
  border-color: var(--primary);
}

.auth-container--rt .auth-step__title {
  margin: 0 0 4px;
  font-size: 13.5px;
  font-weight: 650;
  color: var(--text-primary);
}

.auth-container--rt .auth-step__text {
  margin: 0;
  font-size: 12.5px;
  line-height: 1.5;
  color: var(--text-secondary);
}

.auth-container--rt .auth-step__chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 8px;
  font-size: 12.5px;
  font-weight: 550;
  color: var(--primary);
  background: var(--primary-subtle);
  border: 1px solid var(--primary-muted);
}

.auth-container--rt .auth-spinner {
  width: 40px;
  height: 40px;
  margin: 0 auto 16px;
  border-radius: 50%;
  border: 3px solid var(--border);
  border-top-color: var(--primary);
  animation: auth-spin 0.8s linear infinite;
}

.auth-container--rt .auth-status-icon {
  width: 56px;
  height: 56px;
  margin: 0 auto 16px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  font-weight: 700;
}

.auth-container--rt .auth-status-icon--success {
  color: var(--success, #16a34a);
  background: color-mix(in srgb, var(--success, #16a34a) 14%, transparent);
}

.auth-container--rt .auth-status-icon--error {
  color: var(--danger);
  background: color-mix(in srgb, var(--danger) 14%, transparent);
}

@keyframes auth-spin {
  to { transform: rotate(360deg); }
}

.auth-container--rt .auth-footer {
  background: transparent;
  border-top: 1px solid var(--border-subtle);
  color: var(--text-muted);
  padding: 14px 28px 18px;
  font-size: 12px;
}

.auth-container--rt .auth-page-copy {
  display: none;
}

@media (max-width: 768px) {
  .auth-container--rt .auth-right-section.mobile-full {
    width: 100%;
    flex-direction: column;
    padding: 20px 16px;
  }
}

/* Entry point to the onboarding wizard */
.auth-get-started {
  margin-top: 18px;
}

.auth-get-started__divider {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
  font-size: 12px;
  color: var(--text-muted);
}

.auth-get-started__divider::before,
.auth-get-started__divider::after {
  content: '';
  flex: 1 1;
  height: 1px;
  background: var(--border);
}

.auth-get-started .btn.auth-get-started__btn {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 42px;
  background: var(--surface) !important;
  border: 1px solid var(--border-strong) !important;
  border-radius: 10px !important;
  color: var(--text-primary) !important;
  font-weight: 600;
  transition: background-color 150ms ease, border-color 150ms ease, color 150ms ease;
}

.auth-get-started .btn.auth-get-started__btn:hover:not(:disabled) {
  background: var(--primary-subtle) !important;
  border-color: var(--primary) !important;
  color: var(--primary) !important;
}

.auth-get-started__btn:focus-visible {
  outline: none;
  box-shadow: var(--shadow-focus);
}

@media (prefers-reduced-motion: reduce) {
  .asv-panel,
  .asv-line,
  .asv-code__line,
  .asv-exec__row,
  .asv-panel__dot,
  .asv-stage,
  .asv-stage__icon {
    animation: none !important;
    transition: none !important;
    opacity: 1 !important;
  }

  .asv-exec__fill {
    animation: none;
    width: var(--asv-w);
  }

  .asv-bars span {
    animation: none;
    height: var(--asv-h);
  }

  .asv-ring__value {
    animation: none;
    stroke-dashoffset: 7.8;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/auth-login.css"],"names":[],"mappings":"AAAA,yEAAyE;;AAEzE;EACE,6BAA6B;AAC/B;;AAEA,wEAAwE;AACxE;EACE,yBAAyB;EACzB;;;kEAGgE;EAChE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;0EACwE;EACxE,0BAA0B;EAC1B,kFAAkF;EAClF,0FAA0F;EAC1F,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,kCAAkC;EAClC,2CAA2C;EAC3C,oFAAoF;EACpF,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,iDAAiD;EACjD,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,SAAS;EACT,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,0DAA0D;AAC5D;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,qCAAqC;EACrC,0EAA0E;AAC5E;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;EAChC,2CAA2C;EAC3C,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,6CAA6C;EAC7C,8CAA8C;AAChD;;AAEA;;;EAGE,UAAU;EACV,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,QAAQ;EACR,sBAAsB;EACtB,oDAAoD;EACpD,uDAAuD;AACzD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,uDAAuD;AACzD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAO;EACP,SAAS;EACT,8BAA8B;EAC9B,sFAAsF;EACtF,uDAAuD;AACzD;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,KAAK,UAAU,EAAE,eAAe,EAAE;AACpC;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,KAAK,UAAU,EAAE,eAAe,EAAE;AACpC;;AAEA;EACE,KAAK,mBAAmB,EAAE;AAC5B;;AAEA;EACE,KAAK,oBAAoB,EAAE;AAC7B;;AAEA;EACE,KAAK,sBAAsB,EAAE;AAC/B;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,SAAS;EACX;AACF;;AAEA,wEAAwE;AACxE;EACE,6BAA6B;EAC7B,4FAA4F;EAC5F,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,iCAAiC;EACjC,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,sCAAsC;EACtC,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB;+CAC6C;AAC/C;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;;;EAME,YAAY;EACZ,8CAA8C;EAC9C,gDAAgD;EAChD,qCAAqC;EACrC,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;;;EAGE,0CAA0C;AAC5C;;AAEA;;;EAGE,uCAAuC;EACvC,0CAA0C;EAC1C,aAAa;AACf;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;;;;EAIE,gCAAgC;EAChC,2BAA2B;EAC3B,uBAAuB;EACvB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;;EAIE,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;;EAGE,YAAY;EACZ,qCAAqC;EACrC,iCAAiC;EACjC,uBAAuB;EACvB,8BAA8B;EAC9B,gBAAgB;EAChB,+FAA+F;EAC/F,sBAAsB;EACtB,4EAA4E;AAC9E;;AAEA;;EAEE,2CAA2C;AAC7C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,SAAO;EACP,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,iCAAiC;EACjC,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,iCAAiC;EACjC,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,gCAAgC;EAChC,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,wEAAwE;AAC1E;;AAEA;EACE,oBAAoB;EACpB,8DAA8D;AAChE;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,wBAAwB;EACxB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,WAAW;IACX,sBAAsB;IACtB,kBAAkB;EACpB;AACF;;AAEA,yCAAyC;AACzC;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;;EAEE,WAAW;EACX,SAAO;EACP,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,qCAAqC;EACrC,iDAAiD;EACjD,8BAA8B;EAC9B,qCAAqC;EACrC,gBAAgB;EAChB,kFAAkF;AACpF;;AAEA;EACE,4CAA4C;EAC5C,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE;;;;;;;IAOE,0BAA0B;IAC1B,2BAA2B;IAC3B,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,sBAAsB;EACxB;AACF","sourcesContent":["/* Sign-in page — brand showcase (always dark) + theme-aware auth panel */\n\n.auth-container.auth-container--rt {\n  background: var(--bg-primary);\n}\n\n/* ── Left: brand showcase ─────────────────────────────────────────── */\n.auth-container--rt .auth-left-section {\n  background-color: #060d1a;\n  background-image:\n    radial-gradient(ellipse 70% 55% at 15% 10%, rgba(59, 130, 246, 0.28), transparent 60%),\n    radial-gradient(ellipse 60% 50% at 90% 95%, rgba(20, 184, 166, 0.16), transparent 60%),\n    linear-gradient(165deg, #060d1a 0%, #0a1629 55%, #07111f 100%);\n  color: #e2e8f0;\n  overflow: hidden;\n}\n\n.auth-container--rt .auth-left-section::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background-image: linear-gradient(rgba(148, 163, 184, 0.06) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(148, 163, 184, 0.06) 1px, transparent 1px);\n  background-size: 44px 44px;\n  mask-image: radial-gradient(ellipse 75% 65% at 50% 45%, #000 30%, transparent 80%);\n  -webkit-mask-image: radial-gradient(ellipse 75% 65% at 50% 45%, #000 30%, transparent 80%);\n  pointer-events: none;\n}\n\n.auth-showcase {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 26px;\n  width: min(480px, 84%);\n  max-height: 100%;\n  padding: 32px 0;\n}\n\n.auth-showcase__brand {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 18px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: #f8fafc;\n}\n\n.auth-showcase__brand img {\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n}\n\n.auth-showcase__copy h2 {\n  margin: 0 0 10px;\n  font-size: clamp(26px, 2.6vw, 34px);\n  font-weight: 650;\n  line-height: 1.15;\n  letter-spacing: -0.03em;\n  color: #f8fafc;\n}\n\n.auth-showcase__copy p {\n  margin: 0;\n  max-width: 42ch;\n  font-size: 15px;\n  line-height: 1.55;\n  color: rgba(203, 213, 225, 0.78);\n}\n\n.auth-showcase__points {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px 18px;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.auth-showcase__points li {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  font-size: 13px;\n  color: rgba(203, 213, 225, 0.82);\n}\n\n.auth-showcase__points svg {\n  color: #60a5fa;\n}\n\n/* Product window */\n.asv-window {\n  border-radius: 14px;\n  background: rgba(13, 24, 43, 0.82);\n  border: 1px solid rgba(148, 163, 184, 0.14);\n  box-shadow: 0 30px 70px rgba(0, 0, 0, 0.45), inset 0 1px 0 rgba(255, 255, 255, 0.04);\n  backdrop-filter: blur(6px);\n  overflow: hidden;\n}\n\n.asv-window__bar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  height: 38px;\n  padding: 0 14px;\n  border-bottom: 1px solid rgba(148, 163, 184, 0.1);\n  background: rgba(255, 255, 255, 0.02);\n}\n\n.asv-window__dots {\n  display: inline-flex;\n  gap: 6px;\n}\n\n.asv-window__dots i {\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n  background: rgba(148, 163, 184, 0.28);\n}\n\n.asv-window__title {\n  font-size: 12px;\n  color: rgba(148, 163, 184, 0.85);\n  font-family: var(--font-mono);\n}\n\n.asv-pipeline {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 6px;\n  margin: 0;\n  padding: 12px;\n  list-style: none;\n}\n\n.asv-stage {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 10px;\n  border-radius: 10px;\n  border: 1px solid transparent;\n  transition: background 320ms ease, border-color 320ms ease;\n}\n\n.asv-stage:not(:last-child)::after {\n  content: '';\n  position: absolute;\n  top: 24px;\n  right: -6px;\n  width: 6px;\n  height: 1px;\n  background: rgba(148, 163, 184, 0.25);\n}\n\n.asv-stage__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  color: rgba(148, 163, 184, 0.9);\n  background: rgba(148, 163, 184, 0.08);\n  transition: background 320ms ease, color 320ms ease, box-shadow 320ms ease;\n}\n\n.asv-stage__text {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.asv-stage__label {\n  font-size: 12px;\n  font-weight: 600;\n  color: rgba(226, 232, 240, 0.72);\n}\n\n.asv-stage__meta {\n  font-size: 10.5px;\n  line-height: 1.35;\n  color: rgba(148, 163, 184, 0.62);\n}\n\n.asv-stage.is-done .asv-stage__icon {\n  color: #34d399;\n  background: rgba(52, 211, 153, 0.12);\n}\n\n.asv-stage.is-active {\n  background: rgba(59, 130, 246, 0.1);\n  border-color: rgba(59, 130, 246, 0.35);\n}\n\n.asv-stage.is-active .asv-stage__icon {\n  color: #fff;\n  background: #3b82f6;\n  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.18);\n}\n\n.asv-stage.is-active .asv-stage__label {\n  color: #f8fafc;\n}\n\n.asv-panel {\n  margin: 0 12px 12px;\n  padding: 12px 14px 14px;\n  min-height: 150px;\n  border-radius: 10px;\n  background: rgba(6, 13, 26, 0.7);\n  border: 1px solid rgba(148, 163, 184, 0.08);\n  animation: asv-fade 320ms var(--ease-out, ease);\n}\n\n.asv-panel__head {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 10px;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: rgba(148, 163, 184, 0.8);\n}\n\n.asv-panel__dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);\n  animation: asv-pulse 1.4s ease-in-out infinite;\n}\n\n.asv-line,\n.asv-code__line,\n.asv-exec__row {\n  opacity: 0;\n  animation: asv-rise 360ms var(--ease-out, ease) forwards;\n}\n\n.asv-create {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.asv-line {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 12.5px;\n  color: #cbd5e1;\n}\n\n.asv-line__num {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  border-radius: 5px;\n  font-size: 10px;\n  font-weight: 700;\n  color: #93c5fd;\n  background: rgba(59, 130, 246, 0.14);\n}\n\n.asv-code {\n  font-family: var(--font-mono);\n  font-size: 11.5px;\n  line-height: 1.75;\n  color: #a5b4fc;\n}\n\n.asv-code__line:nth-child(n + 2):nth-last-child(n + 2) {\n  color: #7dd3fc;\n}\n\n.asv-exec {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding-top: 4px;\n}\n\n.asv-exec__row {\n  display: grid;\n  grid-template-columns: 120px 1fr;\n  align-items: center;\n  gap: 12px;\n}\n\n.asv-exec__name {\n  font-size: 12px;\n  color: #cbd5e1;\n}\n\n.asv-exec__track {\n  height: 6px;\n  border-radius: 999px;\n  background: rgba(148, 163, 184, 0.14);\n  overflow: hidden;\n}\n\n.asv-exec__fill {\n  display: block;\n  height: 100%;\n  width: 0;\n  border-radius: inherit;\n  background: linear-gradient(90deg, #3b82f6, #22d3ee);\n  animation: asv-fill 1.6s var(--ease-out, ease) forwards;\n}\n\n.asv-results {\n  display: flex;\n  align-items: center;\n  gap: 22px;\n}\n\n.asv-ring {\n  position: relative;\n  width: 92px;\n  height: 92px;\n  flex-shrink: 0;\n}\n\n.asv-ring > svg {\n  width: 100%;\n  height: 100%;\n  transform: rotate(-90deg);\n}\n\n.asv-ring > svg circle {\n  fill: none;\n  stroke-width: 3.2;\n}\n\n.asv-ring__track {\n  stroke: rgba(148, 163, 184, 0.16);\n}\n\n.asv-ring__value {\n  stroke: #34d399;\n  stroke-linecap: round;\n  stroke-dasharray: 97.4;\n  stroke-dashoffset: 97.4;\n  animation: asv-ring 1.4s var(--ease-out, ease) forwards;\n}\n\n.asv-ring__label {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  gap: 3px;\n  font-size: 11px;\n  font-weight: 600;\n  color: #a7f3d0;\n}\n\n.asv-ring__label svg {\n  width: 16px;\n  height: 16px;\n  color: #34d399;\n  flex-shrink: 0;\n}\n\n.asv-bars {\n  flex: 1;\n  display: flex;\n  align-items: flex-end;\n  gap: 8px;\n  height: 84px;\n}\n\n.asv-bars span {\n  flex: 1;\n  height: 0;\n  border-radius: 4px 4px 2px 2px;\n  background: linear-gradient(180deg, rgba(96, 165, 250, 0.9), rgba(59, 130, 246, 0.35));\n  animation: asv-bar 900ms var(--ease-out, ease) forwards;\n}\n\n@keyframes asv-fade {\n  from { opacity: 0; transform: translateY(4px); }\n  to { opacity: 1; transform: none; }\n}\n\n@keyframes asv-rise {\n  from { opacity: 0; transform: translateY(6px); }\n  to { opacity: 1; transform: none; }\n}\n\n@keyframes asv-fill {\n  to { width: var(--asv-w); }\n}\n\n@keyframes asv-bar {\n  to { height: var(--asv-h); }\n}\n\n@keyframes asv-ring {\n  to { stroke-dashoffset: 7.8; }\n}\n\n@keyframes asv-pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.4; }\n}\n\n@media (max-height: 760px) {\n  .auth-showcase__points {\n    display: none;\n  }\n\n  .auth-showcase {\n    gap: 18px;\n  }\n}\n\n/* ── Right: auth panel (theme-aware) ──────────────────────────────── */\n.auth-container--rt .auth-right-section {\n  background: var(--bg-primary);\n  background-image: radial-gradient(circle at 80% 10%, var(--primary-subtle), transparent 45%);\n  overflow-y: auto;\n  align-items: safe center;\n  padding: 32px 24px;\n}\n\n.auth-container--rt .auth-card {\n  max-width: 420px;\n  max-height: none;\n  margin: auto 0;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: 16px;\n  box-shadow: var(--shadow-lg);\n}\n\n.auth-container--rt .auth-header {\n  min-height: auto;\n  padding: 28px 28px 8px;\n}\n\n.auth-container--rt .auth-header::before {\n  display: none;\n}\n\n.auth-container--rt .auth-logo {\n  width: 48px;\n  height: 48px;\n  padding: 10px;\n  margin-bottom: 14px;\n  border-radius: 12px;\n  background: var(--primary-subtle);\n  border: 1px solid var(--primary-muted);\n  box-shadow: none;\n}\n\n.auth-container--rt .auth-title {\n  margin: 0 0 6px;\n  color: var(--text-primary);\n  font-size: 22px;\n  font-weight: 650;\n  letter-spacing: -0.02em;\n}\n\n.auth-container--rt .auth-subtitle {\n  margin: 0;\n  color: var(--text-secondary);\n  font-size: 13.5px;\n  max-width: 320px;\n}\n\n.auth-container--rt .auth-body {\n  padding: 16px 28px 20px;\n}\n\n.auth-container--rt .auth-login-tabs {\n  display: flex;\n  gap: 4px;\n  padding: 4px;\n  margin-bottom: 18px;\n  border: 1px solid var(--border);\n  border-bottom: 1px solid var(--border);\n  border-radius: 10px;\n  background: var(--bg-tertiary);\n}\n\n.auth-container--rt .auth-login-tab {\n  flex: 1;\n  height: 32px;\n  border: none;\n  border-radius: 7px;\n  background: transparent;\n  color: var(--text-secondary);\n  font-size: 13px;\n  font-weight: 600;\n  transition: background var(--duration-fast, 120ms) ease, color var(--duration-fast, 120ms) ease,\n    box-shadow var(--duration-fast, 120ms) ease;\n}\n\n.auth-container--rt .auth-login-tab:hover {\n  color: var(--text-primary);\n  background: transparent;\n}\n\n.auth-container--rt .auth-login-tab.active {\n  color: var(--text-primary);\n  background: var(--surface);\n  border-bottom: none;\n  box-shadow: var(--shadow-sm);\n}\n\n[data-theme='dark'] .auth-container--rt .auth-login-tab.active {\n  background: var(--surface-selected);\n}\n\n.auth-container--rt .form-label {\n  color: var(--text-secondary);\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.auth-container--rt .form-control,\n.auth-container--rt .form-input,\n.auth-container--rt input[type='email'],\n.auth-container--rt input[type='password'],\n.auth-container--rt input[type='text'],\n.auth-container--rt input[type='tel'] {\n  height: 42px;\n  background: var(--input-background) !important;\n  border: 1px solid var(--input-border) !important;\n  color: var(--text-primary) !important;\n  border-radius: 10px !important;\n  font-size: 14px;\n}\n\n.auth-container--rt .form-control::placeholder,\n.auth-container--rt .form-input::placeholder,\n.auth-container--rt input::placeholder {\n  color: var(--input-placeholder) !important;\n}\n\n.auth-container--rt .form-control:focus,\n.auth-container--rt .form-input:focus,\n.auth-container--rt input:focus {\n  border-color: var(--primary) !important;\n  box-shadow: var(--shadow-focus) !important;\n  outline: none;\n}\n\n.auth-container--rt .relative > span,\n.auth-container--rt .relative > button {\n  color: var(--text-muted) !important;\n}\n\n.auth-container--rt .forgot-password,\n.auth-container--rt a.forgot-password,\n.auth-container--rt .auth-link,\n.auth-container--rt .btn-link {\n  color: var(--primary) !important;\n  background: none !important;\n  border: none !important;\n  padding: 0 !important;\n  font-size: 12.5px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.auth-container--rt .remember-me,\n.auth-container--rt .remember-me-label,\n.auth-container--rt .checkbox-label,\n.auth-container--rt label[for='rememberMe'] {\n  color: var(--text-secondary);\n  font-size: 13px;\n}\n\n.auth-container--rt .remember-me-checkbox {\n  accent-color: var(--primary);\n}\n\n.auth-container--rt .btn-primary,\n.auth-container--rt button[type='submit'].btn-primary,\n.auth-container--rt .auth-submit-btn {\n  height: 42px;\n  background: var(--primary) !important;\n  background-image: none !important;\n  border: none !important;\n  border-radius: 10px !important;\n  font-weight: 600;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.18), inset 0 1px 0 rgba(255, 255, 255, 0.1) !important;\n  color: #fff !important;\n  transition: background var(--duration-fast, 120ms) ease, transform 80ms ease;\n}\n\n.auth-container--rt .btn-primary:hover:not(:disabled),\n.auth-container--rt .auth-submit-btn:hover:not(:disabled) {\n  background: var(--primary-hover) !important;\n}\n\n.auth-container--rt .btn-primary:active:not(:disabled) {\n  transform: translateY(0.5px);\n}\n\n.auth-container--rt .form-error {\n  color: var(--danger);\n  font-size: 12.5px;\n}\n\n.auth-container--rt .form-text {\n  color: var(--text-muted);\n  font-size: 12px;\n  margin-top: 6px;\n}\n\n.auth-container--rt .form-text--success {\n  color: var(--success, #16a34a);\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-top: 4px;\n}\n\n.auth-container--rt .form-input--readonly {\n  background: var(--bg-tertiary) !important;\n  cursor: not-allowed;\n}\n\n.auth-container--rt .auth-muted {\n  color: var(--text-secondary);\n  font-size: 14px;\n  line-height: 1.5;\n  margin: 0;\n}\n\n.auth-container--rt .auth-password-field {\n  position: relative;\n}\n\n.auth-container--rt .auth-password-field .form-input {\n  padding-right: 40px;\n  width: 100%;\n}\n\n.auth-container--rt .auth-password-toggle {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-muted) !important;\n}\n\n.auth-container--rt .divider {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin: 16px 0;\n}\n\n.auth-container--rt .divider::before,\n.auth-container--rt .divider::after {\n  content: '';\n  flex: 1;\n  height: 1px;\n  background: var(--border);\n}\n\n.auth-container--rt .divider-text {\n  color: var(--text-muted);\n  font-size: 12px;\n}\n\n.auth-container--rt .auth-steps {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.auth-container--rt .auth-step {\n  display: flex;\n  gap: 14px;\n  align-items: flex-start;\n}\n\n.auth-container--rt .auth-step__badge {\n  width: 28px;\n  height: 28px;\n  border-radius: 999px;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 2px;\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--primary);\n  background: var(--primary-subtle);\n  border: 1px solid var(--primary-muted);\n}\n\n.auth-container--rt .auth-step__badge--done {\n  color: #fff;\n  background: var(--primary);\n  border-color: var(--primary);\n}\n\n.auth-container--rt .auth-step__title {\n  margin: 0 0 4px;\n  font-size: 13.5px;\n  font-weight: 650;\n  color: var(--text-primary);\n}\n\n.auth-container--rt .auth-step__text {\n  margin: 0;\n  font-size: 12.5px;\n  line-height: 1.5;\n  color: var(--text-secondary);\n}\n\n.auth-container--rt .auth-step__chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  border-radius: 8px;\n  font-size: 12.5px;\n  font-weight: 550;\n  color: var(--primary);\n  background: var(--primary-subtle);\n  border: 1px solid var(--primary-muted);\n}\n\n.auth-container--rt .auth-spinner {\n  width: 40px;\n  height: 40px;\n  margin: 0 auto 16px;\n  border-radius: 50%;\n  border: 3px solid var(--border);\n  border-top-color: var(--primary);\n  animation: auth-spin 0.8s linear infinite;\n}\n\n.auth-container--rt .auth-status-icon {\n  width: 56px;\n  height: 56px;\n  margin: 0 auto 16px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 28px;\n  font-weight: 700;\n}\n\n.auth-container--rt .auth-status-icon--success {\n  color: var(--success, #16a34a);\n  background: color-mix(in srgb, var(--success, #16a34a) 14%, transparent);\n}\n\n.auth-container--rt .auth-status-icon--error {\n  color: var(--danger);\n  background: color-mix(in srgb, var(--danger) 14%, transparent);\n}\n\n@keyframes auth-spin {\n  to { transform: rotate(360deg); }\n}\n\n.auth-container--rt .auth-footer {\n  background: transparent;\n  border-top: 1px solid var(--border-subtle);\n  color: var(--text-muted);\n  padding: 14px 28px 18px;\n  font-size: 12px;\n}\n\n.auth-container--rt .auth-page-copy {\n  display: none;\n}\n\n@media (max-width: 768px) {\n  .auth-container--rt .auth-right-section.mobile-full {\n    width: 100%;\n    flex-direction: column;\n    padding: 20px 16px;\n  }\n}\n\n/* Entry point to the onboarding wizard */\n.auth-get-started {\n  margin-top: 18px;\n}\n\n.auth-get-started__divider {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 12px;\n  font-size: 12px;\n  color: var(--text-muted);\n}\n\n.auth-get-started__divider::before,\n.auth-get-started__divider::after {\n  content: '';\n  flex: 1;\n  height: 1px;\n  background: var(--border);\n}\n\n.auth-get-started .btn.auth-get-started__btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 42px;\n  background: var(--surface) !important;\n  border: 1px solid var(--border-strong) !important;\n  border-radius: 10px !important;\n  color: var(--text-primary) !important;\n  font-weight: 600;\n  transition: background-color 150ms ease, border-color 150ms ease, color 150ms ease;\n}\n\n.auth-get-started .btn.auth-get-started__btn:hover:not(:disabled) {\n  background: var(--primary-subtle) !important;\n  border-color: var(--primary) !important;\n  color: var(--primary) !important;\n}\n\n.auth-get-started__btn:focus-visible {\n  outline: none;\n  box-shadow: var(--shadow-focus);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .asv-panel,\n  .asv-line,\n  .asv-code__line,\n  .asv-exec__row,\n  .asv-panel__dot,\n  .asv-stage,\n  .asv-stage__icon {\n    animation: none !important;\n    transition: none !important;\n    opacity: 1 !important;\n  }\n\n  .asv-exec__fill {\n    animation: none;\n    width: var(--asv-w);\n  }\n\n  .asv-bars span {\n    animation: none;\n    height: var(--asv-h);\n  }\n\n  .asv-ring__value {\n    animation: none;\n    stroke-dashoffset: 7.8;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
